import React from 'react';
import PropTypes from 'prop-types';
import * as apiActions from 'aster-foundation/core/epharmacy/Product/redux/action';
import Image from 'next/image';
import { useDispatch, useSelector } from 'react-redux';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
import useWindowDimensions from '@common/Context/useWindowDimensions';
import { PAGE_TITLES } from '@common/Utility/constants';
import { IC_VIDEO_PDP } from '../../../../public/images';
import { useState } from 'react';

const RichMediaBanners = ({ sku, mediaGalleryEntries, setShowVideo, setSelectedMediaId }) => {
  const dispatch = useDispatch();
  const [richMediaContent, setRichMediaContent] = React.useState([]);
  const [afterRichContent, setAfterRichContent] = React.useState(false);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);


  const fetchRichContent = () => {
    dispatch(
      apiActions.getProductRichMediaContent({
        params: { sku },
        onSuccess: (res) => {
          if (res?.data?.items?.length > 0) {
            setAfterRichContent(true);
            setRichMediaContent(res?.data?.items);
          } else {
            setAfterRichContent(false);
          }
        },
        onError: (error) => {
          setAfterRichContent(false);
          console.log('error', error);
        },
      }),
    );
  };

  React.useEffect(() => {
    if (sku && (guestLogin || userLogin)) {
      fetchRichContent();
    }
  }, [sku, guestLogin, userLogin]);

  const handleVideoPlayer = (id) => {
    setShowVideo(true);
    setSelectedMediaId(id);
  };

  const windowWidth = useWindowDimensions();
  if (
    richMediaContent?.length > 0 &&
    (richMediaContent?.[0]?.mobileMedia !== null || richMediaContent?.[0]?.webMedia !== null)
  ) {
    return richMediaContent?.map((item) =>
      windowWidth?.width <= 480
        ? item?.mobileMedia?.map((itemMedia) => (
            <div className="text-center mb-3">
              <img className="mediaImage" src={itemMedia?.url} alt={PAGE_TITLES?.ONLINE_PHARMACY} />
            </div>
          ))
        : item?.webMedia?.map((itemMedia) => (
            <div className="text-center mb-3">
              <img className="mediaImage" src={itemMedia?.url} alt={PAGE_TITLES?.ONLINE_PHARMACY} />
            </div>
          )),
    );
  }
  return (
    mediaGalleryEntries?.length > 0 &&
    !afterRichContent &&
    mediaGalleryEntries?.map((itemMedia) => (
      itemMedia?.mediaType === 'external-video' ? (
        <div className='videoWrapperRichMedia' key={itemMedia?.id} onClick={() => handleVideoPlayer(itemMedia?.videoContent?.videoUrl?.split('?v=')[1])}>
          <Image src={getImageUrlWithSize(itemMedia?.file, 420, 420)} 
            width={420} 
            height={420}
            className='img-video-1'
            unoptimized
          />
          <Image src={IC_VIDEO_PDP}
            width={64} 
            height={64}
            className='img-video'
          />
        </div>
      ) : (
        <div className="richMediaWrapper" key="3">
        <Image width="350px" height="350px" src={getImageUrlWithSize(itemMedia?.file, 350, 350)} alt={PAGE_TITLES?.ONLINE_PHARMACY} unoptimized/>
      </div>
      )
    ))
  );
};

RichMediaBanners.propTypes = {
  sku: PropTypes.string,
  mediaGalleryEntries: PropTypes.array,
};
RichMediaBanners.defaultProps = {
  sku: '',
  mediaGalleryEntries: [],
};
export default RichMediaBanners;
